import { Loader as MantineLoader } from '@mantine/core';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background-color: var(--app-primary-background-color);
  color: var(--app-primary-text-color);
  @media screen and (max-width: 700px) {
    width: 100%;
    overflow-x: scroll;
  }
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  white-space: nowrap;
  text-align: center;
`;

export const Loader = styled(MantineLoader)`
  ::after {
    border-width: 5px !important;
  }
`;

export const ErrorWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 16px;
  bottom: 0;
  left: 50%;
  width: 90vw;
  height: 90vh;
  background-color: white;
  border-radius: 30px 30px 0 0;
  transform: translateX(-50%);
  z-index: 100;
  animation: fade 0.1s ease-out;
  text-align: center;
  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
